import cx from 'classnames';
import styles from '../List.module.scss';
import { ListItemProps, ListItemType } from "../List.types";

/**
 * A list item component that renders a single item.
 * 
 * @template T - The type of the list item.
 * @param {ListItemProps<T>} props - The properties for the list item.
 * @returns {JSX.Element} The rendered list item.
 */
export const RootListItem = <T extends ListItemType>(props: ListItemProps<T>) => {
  const { id, component: Component, item, ...rest } = props;
  const { itemClassName, itemStyle, ...itemProps } = item;
  return (
    <li
      {...rest}
      className={cx(styles.listItem, itemClassName)}
      style={itemStyle}
    >
      <Component {...itemProps} />
    </li>
  );
}